export default __webpack_public_path__ + "img/76.d39c277.svg";